import api from './api';

export default {
  async getReportTableData() {
    try {
      const response = await api.get('/pnl-progress-report/', { authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  },
  async getPerformanceTableData() {
    try {
      const response = await api.get('/all-performance/', { authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  }
};
